import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";

function Recipe() {
  const [copied, setCopied] = React.useState(false);
  const [inputFieldsHt, setInputFieldsHt] = useState([]) 
  const [inputFieldsHtTool, setInputFieldsHtTool] = useState([])
  const [inputFieldsHtToolStep, setInputFieldsHtToolStep] = useState([])
  const [istrueUrl, setIsTrueIMg] = React.useState(false);
  const [istrueStepUrl, setIsTrueURL] = React.useState([0, false]);
  const [istrueImgUrls, setImageUrlvalid] = React.useState([0, false]);
  const [inputFieldsHtStep, setInputFieldsHtStep] = useState([{
    name:'', 
    author:'',
    body:'', 
    publisher:'', 
    rating:'',
    date:''
}])
  const [inputFieldsHt0, setInputFieldsHt0] = useState({
    name: '',
    description:'',
    Keywords:'',
    contentUrl:'',
    embedUrl:'',
    Creator:'',
    publish_date:'',
    preparation_min:'',
    cooking_min:'',
    Category:'',
    Cuisine:'',
    Servings:'',
    Serving_size:'',
    Calories:'',
    fat:'',
    rating_value:'',
    rating_number:'',
    allowed_Hvalue:'',
    allowed_Lvalue:''
  })
  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  }; 
  const handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name; 
    if(name==='image')
    {
      let isTrueUrlvalid = !value || urlPatternValidation(value);
      if(isTrueUrlvalid === false)
      {
        setIsTrueIMg(true);
      }
      else{
        setIsTrueIMg(false);
      } 
    }
    setInputFieldsHt0((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }})
  }
  const handleChange4 = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...inputFieldsHt];
    list[index][name] = value;
    setInputFieldsHt(list);
  }
  
  const handleChangeTool = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...inputFieldsHtTool];
    list[index][name] = value;
    setInputFieldsHtTool(list);
  }
  const handleChangeToolStep = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...inputFieldsHtToolStep];
    list[index][name] = value;
    setInputFieldsHtToolStep(list);
  }
  const handleChangeStep = (index, evnt) => {
    const { name, value } = evnt.target;    
    const list = [...inputFieldsHtStep];
    list[index][name] = value;
    setInputFieldsHtStep(list);
  }
  function MyButton(props) {
    return <button {...props} />
  } 
  const addInputFieldHt = () => {
    setInputFieldsHt([...inputFieldsHt, {
      imageurl: '',
    }])

  }
  const removeInputFieldsHt = (index) => {
    const rows = [...inputFieldsHt];
    rows.splice(index, 1);
    setInputFieldsHt(rows);
  }
  const addInputFieldHtTool = () => {
    setInputFieldsHtTool([...inputFieldsHtTool, {}])

  }
  const removeInputFieldsHtTool = (index) => {
    const rows = [...inputFieldsHtTool];
    rows.splice(index, 1);
    setInputFieldsHtTool(rows);
  }

  const addInputFieldHtToolStep = () => {
    setInputFieldsHtToolStep([...inputFieldsHtToolStep, {
      step: ""
    }])
  }
  const removeInputFieldsHtToolStep = (index) => {
    const rows = [...inputFieldsHtToolStep];
    rows.splice(index, 1);
    setInputFieldsHtToolStep(rows);
  }

  const addInputFieldHtStep = () => {
    setInputFieldsHtStep([...inputFieldsHtStep, {
      step:'', image:'', name:'', url:''
    }])

  }
  const removeInputFieldsHtStep = (index) => {
    const rows = [...inputFieldsHtStep];
    rows.splice(index, 1);
    setInputFieldsHtStep(rows);
  }
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, []) 
  
  const AddImage = (inputFieldsHt.length > 0)?
   `"image": [
        `+inputFieldsHt.map((items) =>
          `"`+items.imageurl+`"`
      )+` 
      ],
  `:''; 
    const totalTimw = (inputFieldsHt0.preparation_min || inputFieldsHt0.cooking_min)?parseFloat(inputFieldsHt0.preparation_min) + parseFloat(inputFieldsHt0.cooking_min):'' ;
    const recipeIngredient =  `"recipeIngredient": [
          `+inputFieldsHtTool.map((items) =>
          `"`+items.INGREDIENT+`"`
      )+`
    ],`;
    const recipeInstructions = `"recipeInstructions": [
      `+inputFieldsHtToolStep.map((items) =>
      `{
        "@type": "HowToStep",
        "text": "`+items.step+`"
      }`
      )+`
    ],`;
    const reviews =`"reviews": [
      `+inputFieldsHtStep.map((items) =>
      `{
        "@type": "Review",
        "reviewBody": "`+items.body+`",
        "author": {
          "@type": "Person",
          "name": "`+items.author+`"
        },
        "name": "`+items.name+`",
        "datePublished": "`+items.date+`",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "`+items.rating+`"
        },
        "publisher": {
          "@type": "Organization",
          "name": "`+items.publisher+`"
        }
      }`
      )+`
    ]`;
    const HtIsMyCopy2 = 
    `<script type="application/ld+json">
    {
      "@context": "https://schema.org/",
      "@type": "Recipe",
      "name": "`+inputFieldsHt0.name+`",
      `+AddImage+`
      "description": "`+inputFieldsHt0.description+`",
      "keywords": "`+inputFieldsHt0.Keywords+`",
      "author": {
        "@type": "Person",
        "name": "`+inputFieldsHt0.Creator+`"
      },
      "prepTime": "PT`+inputFieldsHt0.preparation_min+`M",
      "cookTime": "PT`+inputFieldsHt0.cooking_min+`M",
      "totalTime": "PT`+totalTimw+`M",
      "nutrition": {
        "@type": "NutritionInformation",
        "calories": "`+inputFieldsHt0.Calories+` cal",
        "servingSize": "`+inputFieldsHt0.Serving_size+`",
        "fatContent": "`+inputFieldsHt0.fat+` g"
      },
      "datePublished": "`+inputFieldsHt0.publish_date+`",
      "recipeCuisine": "`+inputFieldsHt0.Cuisine+`",
      "recipeYield": "`+inputFieldsHt0.Servings+`",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "`+inputFieldsHt0.rating_value+`",
        "bestRating": "`+inputFieldsHt0.allowed_Hvalue+`",
        "worstRating": "`+inputFieldsHt0.allowed_Lvalue+`",
        "ratingCount": "`+inputFieldsHt0.rating_number+`"
      },
      "recipeCategory": "`+inputFieldsHt0.Category+`",
      "video": {
        "@type": "VideoObject",
        "name": "`+inputFieldsHt0.name+`",
        "description": "`+inputFieldsHt0.description+`",
        "thumbnailUrl": "`+inputFieldsHt0.embedUrl+`",
        "uploadDate": "2023-06-21",
        "contentUrl": "`+inputFieldsHt0.contentUrl+`",
        "embedUrl": "`+inputFieldsHt0.embedUrl+`"
      },
      `+recipeIngredient+`
      `+recipeInstructions+`
      `+reviews+`
    }
    </script><!--Recipe Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;

    const resetFun = () => {
      const resetVal = {
        name: '',
        description:'',
        Keywords:'',
        contentUrl:'',
        embedUrl:'',
        Creator:'',
        publish_date:'',
        preparation_min:'',
        cooking_min:'',
        Category:'',
        Cuisine:'',
        Servings:'',
        Serving_size:'',
        Calories:'',
        fat:'',
        rating_value:'',
        rating_number:'',
        allowed_Hvalue:'',
        allowed_Lvalue:''
      };
      setInputFieldsHt0(); 
      setInputFieldsHt0(resetVal);
      setInputFieldsHtStep([]);
      setInputFieldsHtToolStep([]);
      setInputFieldsHt([]);
    }

    return (
        <div className='row mt-5 howto_row'>
          <div className='col-md-8 mb-5 border ps-0'>
              <div className='mt-2 mb-2 article_title'><i className="fa-solid fa-list me-3"></i><b>Recipe</b> </div>
              <div className="row input_fields d-flex">
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Name</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.name} name="name" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Recipe's description</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.description} name="description" className="form-control"/>
                  </div>
                </div> 
                <div className="col-12">
                  <div className="form-group me-2 mb-2">
                  <label>Keywords</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.Keywords} name="Keywords" className="form-control" />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                    {
                      inputFieldsHt.map((data, index) => {
                        const { imageurl } = data;
                        return (
                          <div className="input_fields d-flex" key={index}>
                            <div className="col-10">
                              <div className="form-group me-2 mb-2">
                                <input type="url" onChange={(evnt) => handleChange4(index, evnt)} value={imageurl} name="imageurl" className="form-control" placeholder= {"URL"} />
                              </div>
                            </div>                   
                            <div className="col-2 text-center">
                              {(inputFieldsHt.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsHt(index, evnt)}><i className="fa-solid fa-minus"></i></button> : ''}
                            </div>
                          </div>
                        )
                      })
                    }
                  <div className="col mt-3 mb-3">
                    <button className="btn btn-outline-success addticket" onClick={addInputFieldHt}><i className="fa-solid fa-plus"></i> Add Image</button>
                  </div>
                </div>

                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Video: Content URL</label>
                    <input type="url" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.contentUrl} name="contentUrl" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Video: Embed URL</label>
                    <input type="url" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.embedUrl} name="embedUrl" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Creator</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.Creator} name="Creator" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Date Published</label>
                    <input type="date" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.publish_date} name="publish_date" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Preparation (min)</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.preparation_min} name="preparation_min" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Cooking (min)</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.cooking_min} name="cooking_min" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Category</label>
                    <select onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.Category} name="Category" className="form-control">
                      <option value="">None</option>  
                      <option value="appetizer">Appetizer</option>  
                      <option value="entree">Entree</option>  
                      <option value="dessert">Dessert</option>  
                    </select>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Cuisine</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.Cuisine} name="Cuisine" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Servings</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.Servings} name="Servings" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Nutrition: Serving Size</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.Serving_size} name="Serving_size" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Nutrition: Calories</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.Calories} name="Calories" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Nutrition: Fat (grams)</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.fat} name="fat" className="form-control"/>
                  </div>
                </div>
                <div className='Aggregate-Rating col-12'>
                  <div className="form-group me-2 mb-2">
                    <label>Aggregate Rating</label>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Aggregate rating value</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.rating_value} name="rating_value" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Number of ratings</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.rating_number} name="rating_number" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Highest value allowed</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.allowed_Hvalue} name="allowed_Hvalue" className="form-control"/>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Lowest value allowed</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.allowed_Lvalue} name="allowed_Lvalue" className="form-control"/>
                  </div>
                </div>

                <div className='col-md-12'>
                    {
                        inputFieldsHtTool.map((data, index) => {
                          const { INGREDIENT } = data;
                          return (
                            <div className="input_fields d-flex" key={index}>
                              <div className="col-10">
                                <div className="form-group me-2 mb-2">
                                  <input type="text" onChange={(evnt) => handleChangeTool(index, evnt)} value={INGREDIENT} name="INGREDIENT" className="form-control" placeholder= {"INGREDIENT"} />
                                </div>
                              </div>                   
                              <div className="col-2 text-center">
                                <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsHtTool(index, evnt)}><i className="fa-solid fa-minus"></i></button>
                              </div>
                            </div>
                          )
                        })
                      }
                    <div className="col mt-3 mb-3">
                      <button className="btn btn-outline-success addticket" onClick={addInputFieldHtTool}> <i className="fa-solid fa-plus"></i>  ADD INGREDIENT</button>
                    </div>
                  </div>
                  <div className='col-md-12'>
                    {
                        inputFieldsHtToolStep.map((data, index) => {
                          const { step } = data;
                          return (
                            <div className="input_fields d-flex" key={index}>
                              <div className="col-10">
                                <div className="form-group me-2 mb-2">
                                  <input type="text" onChange={(evnt) => handleChangeToolStep(index, evnt)} value={step} name="step" className="form-control" placeholder= {"STEP"} />
                                </div>
                              </div>                   
                              <div className="col-2 text-center">
                                <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsHtToolStep(index, evnt)}><i className="fa-solid fa-minus"></i></button>
                              </div>
                            </div>
                          )
                        })
                      }
                    <div className="col mt-3 mb-3">
                      <button className="btn btn-outline-success addticket" onClick={addInputFieldHtToolStep}> <i className="fa-solid fa-plus"></i>  ADD STEP</button>
                    </div>
                  </div>
              </div>
              <div className='row'>
                <div className="row input_fields d-flex">
                  <div className='col-12'>
                      <h4>Review</h4>
                  </div>
                </div>
                {
                  inputFieldsHtStep.map((data, index) => {
                    const { author, body, name, publisher, rating, date } = data;
                    return (
                      <div className="row input_fields d-flex" key={index}>                        
                        <div className="col-6">
                          <div className="form-group me-2 mb-2">
                          <label>#{ index+1 }  Review's name</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={name} name="name" className="form-control" placeholder="Name"/>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group me-2 mb-2">
                          <label>Author</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={author} name="author" className="form-control" placeholder="Author"  />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group me-2 mb-2">
                            <label>Review's body</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={body} name="body" className="form-control" placeholder="Body" />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group me-2 mb-2">
                            <label>Publisher</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={publisher} name="publisher" className="form-control" placeholder="Publisher" />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group me-2 mb-2">
                            <label>Rating</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={rating} name="rating" className="form-control" placeholder="Rating" />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group me-2 mb-2">
                            <label>Date</label>
                            <input type="date" onChange={(evnt) => handleChangeStep(index, evnt)} value={date} name="date" className="form-control" placeholder="YYYY-MM-DD" />
                          </div>
                        </div>   
                        <div className='col-12'>
                            <h4>{(inputFieldsHtStep.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsHtStep(index, evnt)}>X</button> : ''}
                            </h4>
                        </div>                     
                      </div>
                    )
                  })
                }
                <div className="col mt-3 mb-3">
                  <button className="btn btn-outline-success addticket" onClick={addInputFieldHtStep}><i className="fa-solid fa-plus"></i> Add REVIEW</button>
                </div>
              </div>
          </div>
          <div className='col-md-4'>
           <div className="card">
             <div className="card-header d-flex">
               <CopyToClipboard onCopy={onCopy} text={HtIsMyCopy2} >
                 <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
               </CopyToClipboard>
                 <MyButton className="btn btn-success" onClick={()=> resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i> Reset</MyButton>
                
             </div>
             <div className="card-body">
               {HtIsMyCopy2}
             </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
          </div>
        </div>
    );
}

export default Recipe